import { SetStateAction } from 'react';
import { MenuStructure } from 'types';
import getConfig from 'next/config';
import { NextRouter } from 'next/router';

export const onNavbarItemMouseEnter = (
  setHook: (value: SetStateAction<boolean>) => void,
  item: MenuStructure
) => setHook(_previousValue => item.children?.length > 0);

export const onNavbarItemMouseOut = (
  setHook: (value: SetStateAction<boolean>) => void
) => setHook(_previousValue => false);

export const delayTimeInMillisecond = 500;
let timeout: ReturnType<typeof setTimeout>;

export const onNavbarMouseEnter = (
  setHook: (value: SetStateAction<boolean>) => void
) => {
  timeout = setTimeout(() => {
    setHook(_previousValue => true);
  }, delayTimeInMillisecond);
};

export const onNavbarMouseOut = (
  setHook: (value: SetStateAction<boolean>) => void
) => {
  clearTimeout(timeout);
  setHook(_previousValue => false);
};

export const onClickHandler = (
  setHook: (value: SetStateAction<boolean>) => void
) => {
  setHook(_previousValue => true);
};

export const onParentCategoryItemHover = (
  event: React.MouseEvent<HTMLElement, MouseEvent>,
  setHook: (value: SetStateAction<number | undefined>) => void
) => {
  const target = event.target as HTMLTextAreaElement;
  const submenuContainerHeight = target.nextElementSibling?.clientHeight;

  setHook(_previousValue => submenuContainerHeight);
};

export const shouldShowMenuItem = (
  menuItem: MenuStructure,
  doctorCountry: string | undefined
) => {
  const { publicRuntimeConfig } = getConfig();
  const countryList = publicRuntimeConfig.CUSTOM_CLAMSHELL_COUNTRY_LIST;

  if (menuItem.link !== '/customcase') {
    return true;
  }
  if (doctorCountry) {
    return countryList.includes(doctorCountry);
  }
  return false;
};

export const isTabActive = (router: NextRouter, link: string) => {
  const slug = router.query.slug;

  if (
    (link.includes('practice-marketing') &&
      slug?.includes('practice-marketing')) ||
    (link.includes('customcase') && router.asPath.includes('customcase'))
  ) {
    return true;
  }

  if (Array.isArray(slug)) {
    for (let i = 0; i < slug.length; i++) {
      if (link === `/category/${slug[i]}`) {
        return true;
      }
    }
  }
  return router.asPath === link;
};
